import { createContext, useContext } from "react";
import type { OfflineSession } from "@/lib/offlineSession";

export type OfflineBootState =
	| "loading"
	| "online" // Clerk fully loaded (or in progress) — normal path
	| "bypass" // offline + valid cached session
	| "expired" // offline + expired session
	| "first-use"; // offline + no session ever stored

export interface OfflineSessionContextValue {
	bootState: OfflineBootState;
	offlineSession: OfflineSession | null;
}

export const OfflineSessionContext =
	createContext<OfflineSessionContextValue | null>(null);

export function useOfflineSession(): OfflineSessionContextValue {
	const ctx = useContext(OfflineSessionContext);
	if (!ctx)
		throw new Error(
			"useOfflineSession must be used inside OfflineSessionContext.Provider",
		);
	return ctx;
}
